
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@Component({
  selector: 'no-settlements',
  templateUrl: './no-settlements.component.html',
   standalone: true,
   imports: [TranslateModule],
   changeDetection: ChangeDetectionStrategy.OnPush
})
export class NoSettlementsComponent {
}

